export const RailOperatorDemoColumns = [
    { field: 'company', headerName: 'Railway Company', width: 180, editable: false, sortable: false },
    { field: 'domain', headerName: 'Domain', width: 180, editable: false, sortable: false },
    { field: 'status', headerName: 'Status', width: 180, editable: false, sortable: false },
    { field: 'version', headerName: 'Version', width: 180, editable: false, sortable: false },
    { field: 'region', headerName: 'Region', width: 180, editable: false, sortable: false },
    { field: 'trainID', headerName: 'Train ID', width: 180, editable: false, sortable: false },
    { field: 'cargoType', headerName: 'Cargo Type', width: 180, editable: false, sortable: false },
];

export const RailOperatorDemoRows = [
    {
        id: 1,
        company: "CN",
        domain: "cargo",
        status: "delayed",
        version: "v1.1",
        region: "ontario",
        trainID: "2001",
        cargoType: "coal",
    },
    {
        id: 2,
        domain: "service",
        status: "*",
        version: "v3.5",
        region: "quebec",
        trainID: "2002",
        cargoType: "grain",
    },
    {
        id: 3,
        domain: "maintenance",
        status: "scheduled",
        version: "v6.2",
        region: "britishColumbia",
        trainID: "2003",
        cargoType: "containers",
    },
    {
        id: 4,
        status: "completed",
        version: "v8.7",
        region: "alberta",
        trainID: "2004",
        cargoType: "crudeOil",

    },
    {
        id: 5,
        status: "requested",
        region: "manitoba",
        trainID: ">",
        cargoType: "automobiles",
    },
    {
        id: 6,
        status: "in-progress",
        region: "novaScotia",
        trainID: "2006",
        cargoType: "wood",
    },
    {
        id: 7,
        region: "saskatchewan",
        trainID: "2007",
        cargoType: "hazardousMaterials",
    },
    {
        id: 8,
        region: "newBrunswick",
        trainID: "2008",
        cargoType: "fertilizers",
    },
    {
        id: 9,
        cargoType: "freight",
        trainID: "2009",
    },
    {
        id: 10,
        trainID: "2010",
    },
]
